<template>
  <b-row>
    <b-form-group>
      <b-form-radio-group v-model="selectedAnswers[0]" :disabled="isFieldDisabled" stacked @change="onAnswerChange($event)">
        <b-form-radio v-for="option in filteredOptions" :key="option.id"
                      :class="isRTLlang ? 'rtl radio-position-inline' : ''"
                      :disabled="isDisabled && noneOptionId !== option.id"
                      :value="option.id">
          <div class="ap-thread-alert-message-preview optionWrapper">
            <MultiChoiceTranslatedOption :lang="lang" :option="option"
                                         :translation-key-initial="translationKeyInitial" />
            <AlertMessage v-if="question.colorCodeEnabled && selectedAnswers[0] === option.id"
                          :backgroundColor="option.colorCoding && option.colorCoding.color"
                          :message="option.colorCoding && option.colorCoding.warningMessage" />
          </div>
        </b-form-radio>

        <div v-if="isOtherOptionEnabled" class="ap-thread-alert-message-preview radio-mrgn-5">
          <b-form-radio :key="otherOptionId" :disabled="isDisabled" :value="otherOptionId">
            {{ otherOptionLabel }}
          </b-form-radio>

          <div v-if="isOtherCommentRequired && otherOptionComment"
               :class="{ 'disabled-area': !isOtherSelected, 'active-area': isOtherSelected }"
               class="other-option-comment">
            <textarea :id="'textarea' + otherOptionId"
                      :disabled="!isOtherSelected"
                      :maxlength="otherCommentMaxLength"
                      :placeholder="otherOptionPlaceholder"
                      :value="otherOptionComment.value"
                      class="other-option-comment-area"
                      @input="onInputOtherComment"
                      @keydown="onKeydownOtherComment">
            </textarea>

            <div :class="{'max-character-limit': otherCommentLength >= otherCommentMaxLength}"
                 class="other-option-comment-count">
              {{ otherCommentLength }} / {{ otherCommentMaxLength }}
            </div>
          </div>

          <span v-if="isOtherSelected && question.hasFieldError"
                class="text-danger fw-bold">Please enter a comment</span>
        </div>
      </b-form-radio-group>

      <div v-if="isEditing" class="optionWrapper mt-12">
        <span v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }"
              :class="{ clearOptionDisabled: this.question.isSkipped }"
              class="activity-form__clear" @click="clearQuestion">
          Clear
        </span>

        <div v-if="canScore" class="scoreWrapper ml-18">
          <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5 score">Score</label>

          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4 score">
            <span v-if="question.isSkippable && optionIds.length === 0">{{ question.skipScore || 0 }}</span>
            <span v-else>{{ score }}</span>
          </div>
        </div>
      </div>
    </b-form-group>
  </b-row>
</template>

<script>
import MultiChoiceTranslatedOption from "@/components/common/multi-choice/multi-choice-translated-option";
import {
  SiteFacingMultiChoiceEditable
} from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-editable";
import AlertMessage from "@/components/common/alert-message.vue";

export default {
  name: "site-facing-multi-choice-single",
  components: { AlertMessage, MultiChoiceTranslatedOption },
  mixins: [SiteFacingMultiChoiceEditable]
};
</script>

<style lang="scss" scoped>
@import "@/assets/multi-choice-other-answer.scss";
</style>
